import { useEffect, useState } from 'react';
import Navbar from '../Navbar';
import * as S from './styled';
import Notifications from '../Notifications';
import { Divider, Drawer } from '@mui/material';
import NavigationHistoryProvider from '../NavigationHistoryProvider';
import { useAppSelector } from '../../redux/hooks';
import { selectFullProfile } from '../../redux/slices/fullProfile';
import SidebarVariation1 from '../Sidebar/sidebarVariation1';
import Sidebar from '../Sidebar';
import { useMediaQuery } from 'react-responsive';
import Loading from '../Loading';

const Layout = ({ children }: { children: any }) => {
  const [open, setOpen] = useState(false);
  const [opensidebar, setOpenSidebar] = useState(true);
  const profile = useAppSelector(selectFullProfile);
  const landingPageId = profile?.landingPageId;

  //Apple iPhone 14 Pro Max viewport width is 430
  const isMobileScreen = useMediaQuery({
    query: '(max-width: 430px) and (min-device-pixel-ratio: 1)' // use 'pixel-ratio' to avoid zooming in on website trigger this variable
  });

  //iPad Air width 820px
  const isIPadScreen = useMediaQuery({
    query: '(max-width: 820px) and (min-device-pixel-ratio: 1)' // use 'pixel-ratio' to avoid zooming in on website trigger this variable
  });

  useEffect(() => {
    if (isMobileScreen) setOpenSidebar(!isMobileScreen);
  }, [isMobileScreen]);

  const renderPage = () => {
    if (landingPageId === 1) {
      // Return page for landingPageId 1
      return (
        <>
          <NavigationHistoryProvider>
            <Navbar
              setOpen={setOpen}
              open={open}
              setOpenSidebar={setOpenSidebar}
              opensidebar={opensidebar}
            />
            <Drawer
              sx={{
                width: 215,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                  width: 215,
                  top: 0
                }
              }}
              variant='persistent'
              anchor='right'
              open={open}
            >
              <Divider />
              <Notifications />
            </Drawer>
            <Drawer
              sx={{
                width: 215,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                  width: 215,
                  top: 0
                },
                overflow: 'hidden',
                position: 'absolute',
                zIndex: 0
              }}
              variant='persistent'
              anchor='left'
              open={opensidebar}
            >
              <SidebarVariation1 />
            </Drawer>
            <S.Container opensidebar={opensidebar}>{children}</S.Container>
            {/*<BreadcrumbsBar />*/}
          </NavigationHistoryProvider>
        </>
      );
    } else if (landingPageId === 2) {
      // Return page for landingPageId 2
      return (
        <>
          <NavigationHistoryProvider>
            <Navbar
              setOpen={setOpen}
              open={open}
              setOpenSidebar={setOpenSidebar}
              opensidebar={opensidebar}
            />
            <Drawer
              sx={{
                width: 215,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                  width: 215,
                  top: 0
                }
              }}
              variant='persistent'
              anchor='right'
              open={open}
            >
              <Divider />
              <Notifications />
            </Drawer>
            <Drawer
              sx={{
                width: 215,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                  width: 215,
                  top: 0
                },
                overflow: 'hidden',
                position: 'absolute',
                zIndex: 0
              }}
              variant='persistent'
              anchor='left'
              open={opensidebar}
            >
              <SidebarVariation1 />
            </Drawer>
            <S.Container opensidebar={opensidebar}>{children}</S.Container>
          </NavigationHistoryProvider>
        </>
      );
    } else if (landingPageId === 3) {
      // Return page for landingPageId 3
      return <div>Landing Page 3</div>;
    } else if (landingPageId === 4) {
      // Return page for landingPageId 4
      return (
        <>
          <Navbar
            setOpen={setOpen}
            open={open}
            setOpenSidebar={setOpenSidebar}
            opensidebar={opensidebar}
          />
          <Drawer
            sx={{
              width: 383,
              flexShrink: 0,
              '& .MuiDrawer-paper': {
                width: 383,
                top: 44
              }
            }}
            variant='persistent'
            anchor='right'
            open={open}
          >
            <Divider />
            <Notifications />
          </Drawer>
          <Drawer
            sx={{
              width: 400,
              flexShrink: 0,
              '& .MuiDrawer-paper': {
                width: 'fit-content',
                top: 0
              },
              overflow: 'hidden',
              position: 'absolute',
              zIndex: 1
            }}
            variant='persistent'
            anchor='left'
            open={opensidebar}
          >
            <Sidebar />
          </Drawer>
          <S.Container opensidebar={opensidebar && !isIPadScreen}>
            {children}
          </S.Container>
          <div>Landing Page 4 for IT purposes</div>
        </>
      );
    } else if (landingPageId === 0) {
      // Return default page for other landingPageId values
      return (
        <>
          <NavigationHistoryProvider>
            <Navbar
              setOpen={setOpen}
              open={open}
              setOpenSidebar={setOpenSidebar}
              opensidebar={opensidebar}
            />
            <Drawer
              sx={{
                width: 383,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                  width: 383,
                  top: 44
                }
              }}
              variant='persistent'
              anchor='right'
              open={open}
            >
              <Divider />
              <Notifications />
            </Drawer>
            <Drawer
              sx={{
                width: 400,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                  width: 'fit-content',
                  top: 0
                },
                overflow: 'hidden',
                position: 'absolute',
                zIndex: 1
              }}
              variant='persistent'
              anchor='left'
              open={opensidebar}
            >
              <Sidebar />
            </Drawer>
            <S.Container opensidebar={opensidebar && !isIPadScreen}>
              {children}
            </S.Container>
            {/*<BreadcrumbsBar />*/}
          </NavigationHistoryProvider>
        </>
      );
    } else {
      return (
        <>
          <NavigationHistoryProvider>
            <Navbar
              setOpen={setOpen}
              open={open}
              setOpenSidebar={setOpenSidebar}
              opensidebar={opensidebar}
            />
            <Loading showLogo/>
          </NavigationHistoryProvider>
        </>
      );
    }
  };

  return renderPage();
};

export default Layout;
